import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
	DataTableModule,
	ButtonModule,
	MultiSelectModule,
	ContextMenuModule,
	DropdownModule
} from 'primeng/primeng';

import { OfferTableComponent } from './offer-table.component';

@NgModule({
  imports: [
    CommonModule,
	TranslateModule,
	RouterModule,
	NgbModule.forRoot(),
	DataTableModule,
	ButtonModule,
	MultiSelectModule,
	ContextMenuModule,
	DropdownModule
  ],
  declarations: [OfferTableComponent],
  exports: [OfferTableComponent]
})
export class OfferTableModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/offer-table/offer-table.module.ts